import Pusher from 'pusher-js';
export const makePusher = (authorize)=>{
    const pusher = new Pusher(window.pusherAppKey, {
        cluster: 'us2',
        channelAuthorization: {
            transport: 'ajax',
            endpoint: '',
            customHandler: authorize
        }
    });
    return {
        subscribe: (channelName)=>{
            return pusher.subscribe(channelName);
        },
        unsubscribe: (channelName)=>{
            return pusher.unsubscribe(channelName);
        },
        channel: (channelName)=>{
            return pusher.channel(channelName);
        }
    };
};
